/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {NavLink} from "react-router-dom";


import {Row, Col} from "react-bootstrap";


import APPLICATION_GLOBALS from "@GLOBALS";


import {AiFillDelete} from "react-icons/all";

import ARRIVAL_ICON from "@Icons/arrival.png";
import ARRIVAL_ACTIVE_ICON from "@Icons/arrival_active.png";


import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";


type MonitoryNoteListElementProps = {
    MONITORY_NOTE: MONITORY_NOTE_INTERFACE;
    MONITORY_NOTE_LIST_TYPE?: "LIST" | "HOME";
    FIRST?: boolean;
};


export const MonitoryNoteListElementComponent: React.FC<MonitoryNoteListElementProps> = ({
    MONITORY_NOTE,
    MONITORY_NOTE_LIST_TYPE = "LIST",
    FIRST = false
}) : JSX.Element | null => {


    if (!MONITORY_NOTE) return null;

    const {MONTHS: {LABELS: MONTH_LABELS}} = APPLICATION_GLOBALS;

    //if (!MONITORY_NOTE?.ProcessStartDate) return null;
    let PROCESS_START_DATE_DAY: number | string = '';
    let PROCESS_START_DATE_HOUR: number | string = '';
    let PROCESS_START_DATE_MINUTES: number | string = '';
    let PROCESS_START_DATE_MONTH: number = 0;
    let NOTE_SUBMIT_AVAILABILITY: boolean | undefined = false;
    let NOTE_INFO_TEXT_AVAILABILITY: boolean | undefined = false;
    if (MONITORY_NOTE?.ProcessStartDate)
    {
        const MONITORY_NOTES_PROCESS_START_DATE = new Date(MONITORY_NOTE?.ProcessStartDate);

        PROCESS_START_DATE_DAY = MONITORY_NOTES_PROCESS_START_DATE.getDate();
        if (PROCESS_START_DATE_DAY < 10) PROCESS_START_DATE_DAY = `0${PROCESS_START_DATE_DAY}`;

        PROCESS_START_DATE_MONTH = MONITORY_NOTES_PROCESS_START_DATE.getMonth() + 1;

        PROCESS_START_DATE_HOUR = MONITORY_NOTES_PROCESS_START_DATE.getHours();
        if (PROCESS_START_DATE_HOUR < 10) PROCESS_START_DATE_HOUR = `0${PROCESS_START_DATE_HOUR}`;

        PROCESS_START_DATE_MINUTES = MONITORY_NOTES_PROCESS_START_DATE.getMinutes();
        if (PROCESS_START_DATE_MINUTES < 10) PROCESS_START_DATE_MINUTES = `0${PROCESS_START_DATE_MINUTES}`;

        const TIME_TO_START: number = (MONITORY_NOTES_PROCESS_START_DATE.getTime() - (new Date()).getTime()) / 1000 / 60;  
        
        NOTE_SUBMIT_AVAILABILITY = TIME_TO_START <= +(MONITORY_NOTE?.MinDelayForSubmit || 0) && !MONITORY_NOTE.IsSubmitted && MONITORY_NOTE?.IsDetailed && new Date() <= new Date(MONITORY_NOTES_PROCESS_START_DATE);
    }
    else
    {
        NOTE_INFO_TEXT_AVAILABILITY = true;
    }

    const MONITORY_NOTE_TRUCKS = [MONITORY_NOTE.FrontTruckRegNo, MONITORY_NOTE.RearTruckRegNo].filter((truck: any) => !!truck);


    let CSS_CLASSES = "monitory-notes-list-element-component monitory-notes-list-element"

    if (MONITORY_NOTE_LIST_TYPE === "HOME") CSS_CLASSES += " home-page-monitory-note";

    if (MONITORY_NOTE.IsSubmitted) CSS_CLASSES += " submitted";

    if (FIRST) CSS_CLASSES += " selected";

    //const NOTE_SUBMIT_AVAILABILITY = TIME_TO_START <= +(MONITORY_NOTE?.MinDelayForSubmit || 0) && !MONITORY_NOTE.IsSubmitted && MONITORY_NOTE?.IsDetailed && new Date() <= new Date(MONITORY_NOTES_PROCESS_START_DATE);

    return (
        <Col xs={12} className={CSS_CLASSES}>
            <Row className={"monitory-note-list-element-content"}>


                <Col xs={8} className={"monitory-note-information"}>
                    <Row as={NavLink} to={`/awizacje/${MONITORY_NOTE.TransportNotificationNo}`} className={"monitory-note-information-content"}>

                        <Col xs={12} className={"monitory-note-process-start note-information"}>
                            {MONITORY_NOTE?.ProcessStartDate != undefined &&
                                <span className={"note-information-value"}>
                                    <span className={"note-process-start-month"}>{PROCESS_START_DATE_DAY}</span>
                                    <span className={"note-process-start-month"}>{MONTH_LABELS[PROCESS_START_DATE_MONTH]} </span>
                                    <span className={"note-process-start-hour"}>{PROCESS_START_DATE_HOUR}:{PROCESS_START_DATE_MINUTES}</span>
                                </span>
                            }
                            {MONITORY_NOTE?.ProcessStartDate == undefined &&
                                <span className={"note-information-value"}>
                                    <span className={"note-process-start-month"}>Data: brak</span>
                                    <span className={"note-process-start-hour"}>Godzina: brak</span>
                                </span>
                            }
                        </Col>

                        <Col xs={12} className={"monitory-note-terminal note-information"}>
                            <span className={"note-information-label"}>{`Awizacja`}: </span>
                            <span className={"note-information-value"}>{MONITORY_NOTE?.TransportNotificationNo}</span>
                        </Col>

                        <Col xs={12} className={"monitory-note-vehicles note-information"}>
                            <span className={"note-information-value"}>{MONITORY_NOTE_TRUCKS.join(" / ")}</span>
                        </Col>

                        <Col xs={12} className={"monitory-note-terminal note-information"}>
                            <span className={"note-information-label"}>{`Baza paliw`}: </span>
                            <span className={"note-information-value"}>{MONITORY_NOTE.TerminalNo}</span>
                        </Col>

                    </Row>
                </Col>


                <Col xs={4} className={"monitory-note-actions"}>
                    <Row className={"monitory-note-actions-content"}>

                        {NOTE_SUBMIT_AVAILABILITY &&
                        <Col xs={12} className={"monitory-note-declare-arrival monitory-note-action"}>
                            <NavLink
                                to={{
                                    pathname: `/awizacje/zglos-przybycie`,
                                    state: {monitoryNoteId: MONITORY_NOTE.TransportNotificationNo, terminalName: MONITORY_NOTE.TerminalNo}
                                }}
                                title={`Zgłoś przybycie`}
                            >
                                <img src={FIRST ? ARRIVAL_ACTIVE_ICON : ARRIVAL_ICON} alt={`Zgłoś przybycie`} />
                                <span>{`Zgłoś przybycie`}</span>
                            </NavLink>
                        </Col>
                        }

                        {NOTE_INFO_TEXT_AVAILABILITY &&
                        <Col xs={12} className={"monitory-note-declare-arrival monitory-note-action"}>
                            <span>{`Zgłoś przybycie na kiosku stacjonarnym`}</span>
                        </Col>
                        }

                        {/*{!MONITORY_NOTE?.IsSubmitted && MONITORY_NOTE_LIST_TYPE === "LIST" &&*/}
	                    {/*<Col xs={12} className={`monitory-note-delete monitory-note-action`}>*/}
		                {/*    <NavLink*/}
			            {/*        to={{*/}
                        {/*            pathname: "/awizacje/usun",*/}
                        {/*            state: {monitoryNoteId: MONITORY_NOTE?.TransportNotificationNo}*/}
                        {/*        }}*/}
			            {/*        title={``}*/}
		                {/*    >*/}
			            {/*        <AiFillDelete />*/}
		                {/*    </NavLink>*/}
	                    {/*</Col>*/}
                        {/*}*/}

                        {!!MONITORY_NOTE?.IsSubmitted &&
                        <Col xs={12} className={"monitory-note-submitted-status monitory-note-action"}>
                            <img src={ARRIVAL_ICON} alt={``} />
                            <span>{`Przedłożona`}</span>
                        </Col>
                        }

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default MonitoryNoteListElementComponent;
